import { ChangeEvent, useState } from 'react';
import { debounce } from 'ts-debounce';

export const InputTextDebounce = (props: {
	value: string | undefined;
	onChange: (event: ChangeEvent<HTMLInputElement>) => void;
	className?: string;
	id?: string;
	disabled?: boolean;
}) => {
	const [localValue, setLocalValue]: [string | undefined, any] = useState(props.value);

	const debouncedFunction = debounce(props.onChange, 1000, {});

	function wrappingFunction(event: ChangeEvent<HTMLInputElement>) {
		setLocalValue(event.target.value);
		debouncedFunction(event);
	}

	return (
		<input
			id={props.id}
			onChange={wrappingFunction}
			type="text"
			value={localValue}
			className={props.className}
			disabled={props.disabled || false}
		/>
	);
};
